<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      item-key="id"
      :options.sync="tableOptions"
      :server-items-length="count"
      :items-per-page="5"
      :headers="headers"
      :items="items"
      @input="$emit('update:selected', $event)"
      :footer-props="footerTable"
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      :loading="loading"
      disable-sort
    >
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template v-slot:[`item.eventSlot`]="{ item }">
        <div>{{ item.eventSlot.title }}</div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon color="primary">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="() => $refs['change-slot-dialog'].open(item)">
              <v-list-item-title style="cursor: pointer">Chuyển đăng ký</v-list-item-title>
            </v-list-item>
            <v-list-item @click="() => onRemove(item)">
              <v-list-item-title style="cursor: pointer;" class="red--text">Huỷ đăng ký</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <EventTabReportUpdateDialog ref="change-slot-dialog" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import EventTabReportUpdateDialog from './EventTabReportUpdateDialog.vue'

const headers = [
  { text: 'Học sinh', value: 'student' },
  { text: 'Workshop', value: 'eventSlot' },
  { text: 'Thao tác', value: 'actions', align: 'end' }
]
export default {
  components: { CardStudentName, EventTabReportUpdateDialog },
  data: () => ({ tableOptions: {}, headers }),
  methods: {
    ...mapActions({
      requestPageSettings: 'eventSlotStudents/requestPageSettings',
      remove: 'eventSlotStudents/remove'
    }),
    onRemove(item) {
      this.$dialog.confirm({
        title: 'Huỷ đăng ký',
        text: `Thao tác này sẽ xoá đăng ký của "${get(item, 'student.name')} (${get(
          item,
          'student.code_short'
        )})" đối với Workshop "${get(
          item,
          'eventSlot.title'
        )}". Thao tác này sẽ không thể hoàn tác. Bạn có chắc chắn muốn thực hiện thao tác này?`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.remove(item.id)
            this.$alert.success('Huỷ đăng ký workshop thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
  },
  computed: {
    ...mapState('eventSlotStudents', ['count', 'items', 'pageText', 'loading']),
    footerTable() {
      const footer = {
        'items-per-page-text': 'Số đăng ký mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>
